import { Component, Input, forwardRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-toggle',
  templateUrl: './app-toggle.component.html',
  styleUrls: ['./app-toggle.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppToggleComponent),
      multi: true
    }
  ]
})
export class AppToggleComponent implements ControlValueAccessor {

  @Input() value: boolean = false
  @Input() label: string = '';
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() customClass: string = '';

  @Output() stateChanged = new EventEmitter(); 

  private onChange: (val: boolean) => void = () => {};
  private onTouch: () => void = () => {};

  writeValue(val: any): void {
    this.value = !!val;
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  };

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  };

  toggle() {
    this.value = !this.value;
    this.onTouch();
    this.onChange(this.value);
    this.stateChanged.emit(this.value);
  }

  
  constructor() { }

}
